import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { GetDefinitionsGuard } from 'app/core/store/definitions/definitions.resolve';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { Observable } from 'rxjs';
import * as fromRoot from '..';
import { RelocationsLoadAction } from './relocations.actions';
import { logger } from 'app/core/util/logger';
import { goAction } from '../router/router.actions';

/**
 * Guard to refresh relocations list
 */
@Injectable({ providedIn: 'root' })
export class RefreshRelocationsFilterGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    logger.debug(`In RefreshRelocationsFilterGuard`);
    this.store.dispatch(new RelocationsLoadAction());
    this.store.dispatch(goAction({ path: 'relocations' }));
    return false;
  }

  getDependencies(): any {
    return [AuthorizationGuard, GetDefinitionsGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'canRelocate',
    };
  }
}
